import ImageCarousel from "@/components/ui/image-carousel";

import type {CitationFile} from "../types";

/** Matches compact carousel thumb row (`max-h-36`) + vertical padding. */
const IMAGE_BOX_MIN_HEIGHT = "min-h-40";

export function CitationImageSection({title, files}: {title: string; files: CitationFile[]}) {
  if (!files.length) return null;

  return (
    <div className="flex min-w-0 flex-col gap-2">
      <p className="text-muted-foreground line-clamp-2 min-h-8 shrink-0 text-xs leading-snug font-medium">
        {title}
      </p>
      <div
        className={`border-border ${IMAGE_BOX_MIN_HEIGHT} w-full min-w-0 overflow-hidden rounded-md border bg-muted/30`}
      >
        <ImageCarousel
          compact
          images={files.map((f) => f.url)}
          thumbnails={files.map((f) => f.thumb_url ?? f.url)}
        />
      </div>
    </div>
  );
}
